import * as React from 'react'
import { IOWidget, Updater, any, async, fromJSX, nothing } from 'widgets-for-react'
import { BlogTeasersLayout, PageType } from './blogTeasersLayout'
import { BlogTeasersState } from './blogTeasersState'

export const blogTeasersWidget =
  (
    pageType: PageType,
    title: string
  ): IOWidget<BlogTeasersState, Updater<BlogTeasersState>> =>
  (blogTeasersState) =>
    any([
      async(blogTeasersState),
      blogTeasersState.kind == 'unloaded'
        ? nothing()
        : fromJSX(() => (
            <BlogTeasersLayout
              kind={pageType}
              title={title}
              blogTeasers={
                blogTeasersState.kind == 'loaded'
                  ? blogTeasersState.value
                  : blogTeasersState.kind == 'loading'
                  ? 'loading'
                  : 'error'
              }
            />
          )),
    ])
